﻿(function ($, document) {
    $(document).ready(function () {
        $('[data-map-location]').each(function (i, n) {
            var $link = $(this);
            $link.text($link.data('map-label-show'));
        });

        $(document).on('click', '[data-map-location]', function (e) {
            e.preventDefault();
            var $link = $(this);
            var isLoaded = $link.data('map-loaded') || false;
            if (isLoaded) {
                $link.siblings('.delivery-address-pod__map').slideUp(200, function () {
                    $link.text($link.data('map-label-show'));
                    $(this).remove();
                });
                $link.data('map-loaded', false);
            } else {
                $('.delivery-address-pod__map').slideUp(200, function () {
                    var $mapLink = $(this).siblings('[data-map-location]');
                    $mapLink.text($mapLink.data('map-label-show'));
                    $mapLink.data('map-loaded', false);
                    $(this).remove();
                });

                var timestamp = (new Date()).getTime();

                var location = [];
                location[0] = $link.data('map-location');
                $('<div id=\"map-' + timestamp + '\" class=\"delivery-address-pod__map\" style=\"display:none;\"></div>')
                    .data('map-location', location)
                    .insertAfter($link)
                    .slideDown(200, function () {
                        $link.text($link.data('map-label-hide'));

                        var map = new Maplace({
                            map_div: '#map-' + timestamp,
                            locations: location,
                            map_options: {
                                zoom: 15,
                                disableDefaultUI: true
                            }
                        }).Load();
                        $link.data('map-loaded', true);
                    })
                ;

            }
        });
    });

})(jQuery, document);